<template>
  <main-layout>
    <v-container>
      <v-layout>
        <v-flex>
          <h1>
            {{ $t('First Announcement')
            }}<a
              href="https://blog.zwiz.app/first-announcement/"
              target="_blank"
              rel="noopener noreferrer"
              class="primary--text"
              ><i style="font-size: 18px" class="ml-1 fas fa-question-circle"></i
            ></a>
          </h1>
          <p>{{ $t('Set up the first reply dialog') }}</p>
        </v-flex>
      </v-layout>

      <div style="position: relative">
        <v-container>
          <transition name="fade">
            <intent-item
              v-model="intent"
              is-first-announcement
              hide-priority
              hide-copy
              hide-delete
              hide-question
            ></intent-item>
          </transition>
        </v-container>
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import IntentItem from '../intent/intent-item'

export default {
  components: { IntentItem },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  },
  data() {
    return {
      loading: true,
      intent: {
        intentname: '{first_announcement_message}',
        q_type: 'text',
        a_type: 'json',
        q_val: '{first_announcement_message}',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        isShow: false,
        time_setting: {
          Monday: { status: true, openat: null, closeat: null },
          Tuesday: { status: true, openat: null, closeat: null },
          Wednesday: { status: true, openat: null, closeat: null },
          Thursday: { status: true, openat: null, closeat: null },
          Friday: { status: true, openat: null, closeat: null },
          Saturday: { status: true, openat: null, closeat: null },
          Sunday: { status: true, openat: null, closeat: null }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    this.loading = true
    await this.getIntent()
    setTimeout(() => {
      this.loading = false
    }, 500)

    if (
      this.selectedBot.theme == 'ecommercebasic' &&
      !['allinonechat'].includes(this.$route.name)
    ) {
      await this.$store.dispatch('loadCategory')
      this.$store.dispatch('loadProducts')
      this.$store.dispatch('loadCharges')
      this.$store.dispatch('loadSetting')
    }
  },
  methods: {
    async getIntent() {
      const payload = {
        pageid: this.selectedBot.pageid,
        intent_name: '{first_announcement_message}'
      }

      api.getIntent(payload, (error, response) => {
        if (response && response.data && response.data.length) {
          const [intent] = response.data
          this.intent = {
            ...intent,
            id: intent.id,
            intentname: intent.intentname,
            q_type: intent.q_type,
            a_type: intent.a_type,
            q_val: intent.q_val,
            a_val: intent.a_val,
            context_in: intent.context_in,
            context_out: intent.context_out,
            pageidlist: intent.pageidlist,
            userstatus: intent.userstatus,
            usertags: intent.usertags,
            linenoti_status: intent.linenoti_status,
            linenoti_text: intent.linenoti_text,
            linenoti_spec_ids: intent.linenoti_spec_ids,
            starttime: intent.starttime,
            endtime: intent.endtime,
            intentstatus: intent.intentstatus,
            isShow: false,
            created_at: intent.created_at,
            created_by: intent.created_by
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/FirstAnnouncement/index.vue